;(function () {
    'use strict';

    var galleryItems = document.querySelectorAll('.js-gallery-item');
    Array.prototype.forEach.call(galleryItems, function(galleryItem) {

        onClickOrTap(galleryItem, function(e)
        {
            e.preventDefault();
            var gallery = getClosest(galleryItem, '.js-gallery');
            var links = gallery.querySelectorAll('.js-gallery-item');
            if (links.length > 0) {
                var items = [];
                var item, size;
                // build items list
                Array.prototype.forEach.call(links, function(link) {
                    size = link.getAttribute('data-gallery-size').split('x');
                    item = {
                        src: link.getAttribute('href'),
                        w: parseInt(size[0], 10),
                        h: parseInt(size[1], 10),
                        title: link.getAttribute('data-gallery-title')
                    };
                    if(link.children.length > 0) {
                        item.msrc = link.children[0].querySelector('img').getAttribute('src');
                    }
                    items.push(item);
                });
                var pswpElement = document.querySelector('.js-gallery-photoswipe');
                var activeIndex = galleryItem.getAttribute('data-gallery-index');

                var options = {
                    index: activeIndex - 1,
                    closeOnScroll: false,
                    closeOnVerticalDrag: false,
                    closeElClasses: ['ui', 'top-bar'],
                    clickToCloseNonZoomable: false,
                    bgOpacity: 0.9,
                    loop: false,
                    timeToIdle: 40000000,

                    closeEl:true,
                    captionEl: true,
                    fullscreenEl: false,
                    zoomEl: false,
                    shareEl: false,
                    counterEl: true,
                    arrowEl: true,
                    preloaderEl: true,
                    tapToClose: true
                };

                var photoSwipe = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
                photoSwipe.init();
            }

        });
    });
}());
